import { Routes } from '@angular/router';
import { SigninComponent } from './components/signin/signin.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthGuard } from './guards/auth.guard';
import { HomeComponent } from './components/home/home.component';
import { SignupComponent } from './components/signup/signup.component';
import { AccountComponent } from './components/account/account.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LoadingComponent } from './components/loading/loading.component';

export const routes: Routes = [  
  // **NEW INITIAL REDIRECT**
  // On root path, redirect to '/initialize' which will handle auth state and further redirects
  { path: '', redirectTo: 'initialize', pathMatch: 'full' },
  {
    path: 'initialize',
    component: LoadingComponent,
    canActivate: [AuthGuard], // This guard will handle the initial routing based on auth state
  },
  // Public pages (no nav)
  { 
    path: 'home', // Changed '' to 'home' as '' is now for redirection
    component: HomeComponent 
  },
  { 
    path: 'signin', 
    component: SigninComponent 
  },
  {
    path: 'signup',
    component: SignupComponent
  },  
  // Protected pages (with nav bar)
  {
    path: '', // This will now serve as the base for authenticated routes
    component: LayoutComponent,
    canActivate: [AuthGuard], // Still protect these routes directly
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'account', component: AccountComponent },
    ]
  },
  // Fallback for any unmatched routes
  { path: '**', redirectTo: 'initialize' } // Redirect to initialize for unhandled paths
];
